import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 0c-.018 0-1.087 10-1.087 10H45C40.44 3.928 33.179 0 25 0ZM24.999 50c8.179 0 15.44-3.928 20.001-10H4.998c4.56 6.072 11.822 10 20 10ZM49.499 20H23.913L25 30h24.499c.328-1.615.5-3.287.5-5a25.11 25.11 0 0 0-.5-5Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 30V0C11.193 0 0 11.193 0 25c0 1.712.173 3.384.5 5H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m13.794 11.956 1.62 4.982h5.238l-4.238 3.08L18.033 25l-4.239-3.08L9.556 25l1.62-4.982-4.239-3.08h5.239l1.618-4.982Z"
}));
FlagTG.displayName = 'FlagTG';
export default withFlagWrapper(FlagTG);
//# sourceMappingURL=index.js.map